/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMyFitAccountIfNotExistsDto } from '../../models/create-my-fit-account-if-not-exists-dto';

export interface MemberControllerMyFitAccount$Params {
}

export function memberControllerMyFitAccount(http: HttpClient, rootUrl: string, params?: MemberControllerMyFitAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMyFitAccountIfNotExistsDto>> {
  const rb = new RequestBuilder(rootUrl, memberControllerMyFitAccount.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateMyFitAccountIfNotExistsDto>;
    })
  );
}

memberControllerMyFitAccount.PATH = '/api/members/my-fit-account';
